import { Component } from '@angular/core';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { ApiMethod } from '../../apimethods/api-method';
import { UserProfileModel } from './user-profile-model';
declare var $;

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
/** user-profile component*/
export class UserProfileComponent {
  modelItem: UserProfileModel = new UserProfileModel();
  showModal: boolean;
  content: string;
  title: string;
  public SQList: any;
  QuestionID: any;
  topIconHide: string = localStorage.hideTopIcon;
  ImageBase64: string = '../../../assets/Images/userLogo.jpg';
  multiPublist: string = localStorage.multiPublist;
  /** user-profile ctor */
  constructor() {
  }
  ngOnInit(): void {
    $('#ddlGender').select2({
      placeholder: "Select Gender",
    });
    this.loadGeneralmethod();
    $("#ddlSQList,#ddlPubList,#ddlRoleList").select2({ dropdownParent: "#myModal" });


  }

  loadGeneralmethod() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <UserProfileModel>data["UserProfile"];
        this.getuserprofile();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }


  emailidOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = '';
      return false;
    }
    return true;

  }
  
  pubList: any; currentPubId: any;
  roleList: any; currentRoleId: any;

  getuserprofile(): void {
    $("#LoadingImage").show();
    var UserData = {
      LoginId: localStorage.aLoginID,
    }
    ApiMethod.postMethod(this.modelItem.UserProfile, UserData).subscribe(
      result => {
        $("#LoadingImage").hide();
        let itemL = result.aitemList;
        this.SQList = JSON.parse(JSON.stringify(result.aSQitemList));

        this.roleList = result.roleList;
        this.currentRoleId = localStorage.roleId;

        this.pubList = result.pubList;
        this.currentPubId = localStorage.aPubID;


        $('#aLoginName').html(itemL.LoginName);
        $('#lblName').html(itemL.LoginName);
        $('#txtLoginName').val(itemL.LoginName);
        $('#lblEmailID').html(itemL.EmailID);
        $('#txtEmailID').val(itemL.EmailID);

        $('#lblPhone').html(itemL.PhoneNo);
        $('#txtPhoneNo').val(itemL.PhoneNo);
         
        this.QuestionID = itemL.SecurityQuestionID;
        $('#ddlSQList').val(itemL.SecurityQuestionID).change();
        $('#txtSQAnswer').val(itemL.QuestionAnswer);

        if (itemL.Image != null && itemL.Image.trim() != '') {
          $('.imgProfile').attr('src', itemL.Image);
          this.ImageBase64 = itemL.Image;
        }

        if (itemL.DOB != null) {
          $('#lblbirthday').html(GlobalConstants.FormatDate(itemL.DOB, null));
          $('#txtDOB').val(itemL.DOB.split('T')[0]);
        }

        $('#lblGender').html(itemL.Gender);
        $('#ddlGender').val(itemL.Gender).change();

        $('#chkRememberMe').prop("checked", (itemL.IsRemember == null ? 0 : itemL.IsRemember));
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  UpdateProfile(): void {
    if (localStorage.aUpdateMode == 'AccessChange') {
      localStorage.aPubID = $('#ddlPubList').val();
      localStorage.roleId = $('#ddlRoleList').val();
      ngswal({
        position: 'top-end',
        type: "success",
        title: "Updated !",
        text: 'Access Changes Updated',
        showConfirmButton: false,
        timer: 1500
      });
      this.hide();
    }
    else {
      let pwdReg = new RegExp(this.modelItem.PasswordFormat);
      if (localStorage.aUpdateMode == 'Photo' && $('#imageUploadForm').val() == '') {
        ngswal("Warning !", "Select Image !", "warning");
      }
      else if ($('#txtLoginName').val() == '' && localStorage.aUpdateMode == 'Name') {
        ngswal("Warning !", "Enter Name !", "warning");
      }
      else if ($('#ddlGender').val() == null && localStorage.aUpdateMode == 'Gender') {
        ngswal("Warning !", "Select Gender !", "warning");
      }
      else if ($('#txtDOB').val() == '' && localStorage.aUpdateMode == 'DOB') {
        ngswal("Warning !", "Select DOB !", "warning");
      }
      else if ($('#txtEmailID').val() == '' && localStorage.aUpdateMode == 'EmailID') {
        ngswal("Warning !", "Enter EmailID !", "warning");
      }
      else if ($('#txtPhoneNo').val() == '' && localStorage.aUpdateMode == 'PhoneNo') {
        ngswal("Warning !", "Enter PhoneNo !", "warning");
      }
      else if (($('#ddlSQList').val() == 0 || $('#txtSQAnswer').val() == '') && localStorage.aUpdateMode == 'Password') {
        ngswal("Warning !", "Invalid Security Questions !", "warning");
      }
      else if (($('#txtOldPassword').val() == '' || $('#txtNewPassword').val() == '') && localStorage.aUpdateMode == 'Password') {
        ngswal("Warning !", "Invalid Entry !", "warning");
      }
      else if (!pwdReg.test($('#txtNewPassword').val()) && localStorage.aUpdateMode == 'Password') {
        ngswal("Warning !", this.modelItem.PasswordMsg, "warning");
      }
      else {
        if (localStorage.aUpdateMode != 'RememberMe')
          $("#LoadingImagePopup").show();
        var UserData = {
          UserID: localStorage.aLoginID,
          LoginName: $('#txtLoginName').val(),
          Gender: $('#ddlGender').val(),
          DOB: $('#txtDOB').val(),
          EmailID: $('#txtEmailID').val(),
          PhoneNo: $('#txtPhoneNo').val(),
          SecurityQuestionID: $('#ddlSQList').val(),
          QuestionAnswer: $('#txtSQAnswer').val(),
          OldPassword: $('#txtOldPassword').val(),
          NewPassword: $('#txtNewPassword').val(),
          Image: this.ImageBase64,                                                                            
          RememberMe: $('#chkRememberMe').prop("checked"),
          UpdateMode: localStorage.aUpdateMode
        };
        ApiMethod.postMethod(this.modelItem.ProfileUpdate, UserData).subscribe(
          resonse => {
            if (localStorage.aUpdateMode != 'RememberMe') {
              ngswal(resonse);
              ngswal("Info !", resonse, "info");
            }
            this.getuserprofile();
            $('.imgProfile').attr('src', this.ImageBase64);
            $("#LoadingImagePopup").hide();
            this.hide();
          },   
          error => {
            //console.error(error)
            ngswal("Failed !", error.error.Message, "warning");
            $("#LoadingImagePopup").hide();
          }
        );

      }
    }

  }


  show(aid): void {
    localStorage.aUpdateMode = aid;
    if (aid == 'RememberMe') {
      this.UpdateProfile();
    }
    else {
      $('.divProfile').hide();
      $('#div' + aid).show();
      this.showModal = true; // Show-Hide Modal Check
      this.title = aid + " Update";    // Dynamic Data
      $('#ddlSQList').val(this.QuestionID).change();
      $('#txtOldPassword').val('');
      $('#txtNewPassword').val('');
      $("#imageUploadForm").val(null);
      this.ImageBase64 = $('.imgProfile').attr('src');
    }
  }
  //Bootstrap Modal Close event
  hide() {
    this.showModal = false;
  }

  fileChangeEvent(fileInput: any) {
    var ext = $('#imageUploadForm').val().toString().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1 && $('#imageUploadForm').val() != '') {
      ngswal("Warning !", "Invalid image format !", "warning");
      return false;
    }
    else if (fileInput.currentTarget.files[0].size > 2000000) {
      ngswal("Warning !", "Please upload Photo less than 2MB !", "warning");
      return false;
    }

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.ImageBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
    return true;
  }

  changeAccessId(changeType): void {

  }

}
